import styled from "@emotion/styled";

import Banner from "metabase/components/Banner";

export const InfoBanner = styled(Banner)`
  margin-bottom: 0.5rem;
`;
